import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Share = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 20 21"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_977_56191)">
        <path
          d="M1.11719 10.2697C1.11719 11.0549 1.42911 11.8079 1.98433 12.3632C2.53955 12.9184 3.2926 13.2303 4.0778 13.2303C4.863 13.2303 5.61605 12.9184 6.17127 12.3632C6.72649 11.8079 7.03841 11.0549 7.03841 10.2697C7.03841 9.48449 6.72649 8.73145 6.17127 8.17622C5.61605 7.621 4.863 7.30908 4.0778 7.30908C3.2926 7.30908 2.53955 7.621 1.98433 8.17622C1.42911 8.73145 1.11719 9.48449 1.11719 10.2697Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.9609 4.34831C12.9609 5.13351 13.2729 5.88655 13.8281 6.44178C14.3833 6.997 15.1363 7.30892 15.9215 7.30892C16.7068 7.30892 17.4598 6.997 18.015 6.44178C18.5702 5.88655 18.8822 5.13351 18.8822 4.34831C18.8822 3.5631 18.5702 2.81006 18.015 2.25484C17.4598 1.69962 16.7068 1.3877 15.9215 1.3877C15.1363 1.3877 14.3833 1.69962 13.8281 2.25484C13.2729 2.81006 12.9609 3.5631 12.9609 4.34831Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.9609 16.1906C12.9609 16.9758 13.2729 17.7288 13.8281 18.2841C14.3833 18.8393 15.1363 19.1512 15.9215 19.1512C16.7068 19.1512 17.4598 18.8393 18.015 18.2841C18.5702 17.7288 18.8822 16.9758 18.8822 16.1906C18.8822 15.4054 18.5702 14.6523 18.015 14.0971C17.4598 13.5419 16.7068 13.23 15.9215 13.23C15.1363 13.23 14.3833 13.5419 13.8281 14.0971C13.2729 14.6523 12.9609 15.4054 12.9609 16.1906Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.74609 8.9872L13.2594 5.63184"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.74609 11.5532L13.2594 14.9086"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_977_56191">
          <rect width="20" height="20" fill="white" transform="translate(0 0.269531)" />
        </clipPath>
      </defs>
    </svg>
  );
};

Share.displayName = 'Share';
